document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('resize', changeItemsOrder);

    changeItemsOrder();

    function changeItemsOrder() {
        const clinicalResults = document.querySelector('.single-product-clinical-results-component');
        const productDescription = document.querySelector('.single-product-short-description');
        const productSize = document.querySelector('.product-size');
        const productPrice = document.querySelector('.product-price');
        const addToCartBtn = document.querySelector('.single-product-add-to-cart-button-wrap');
        const satisfactionGuarantee = document.querySelector('.satisfaction-guarantee');

        if (clinicalResults && satisfactionGuarantee && window.innerWidth <= 768 ) {
            clinicalResults.before(productSize, productPrice, addToCartBtn, satisfactionGuarantee, productDescription);
        } else if (productDescription && productSize) {
            productDescription.after(productSize, productPrice, addToCartBtn, satisfactionGuarantee);
        }
    }
});